import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=1c9ef7e6&scoped=true"
import script from "./mainHeader.vue?vue&type=script&lang=js"
export * from "./mainHeader.vue?vue&type=script&lang=js"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=1c9ef7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ef7e6",
  null
  
)

export default component.exports